import TemplateView from '../../../../../../TemplateView'
import messageResource from '../../../../../../messageResource'

export default class RemoveAllConfirmation extends TemplateView {
    constructor({
        onConfirmButtonClick = () => {},
        onCancelButtonClick = () => {}
    }) {
        super()

        this.actions = {
            onConfirmButtonClick,
            onCancelButtonClick
        }

        this.state = {
            year: ''
        }

        this.onStatePropertyChanged('year', (year) => {
            this.$title.text(messageResource.getMessage('work_schedule.delete_holidays_confirm_title', [year]))
        })
    }

    templateHtml() {
        return '<div class="operationConfirmDialog">' +
               '  <div class="operationConfirmDialogInnerContainer">' +
               '    <div class="warningIcon"></div>' +
               '    <div class="title"/>' +
               '    <div class="orangeBlock">' +
               '       <%=confirmationText%>' +
               '    </div>' +
               '    <div class="buttonsContainer">' +
               '      <div class="submitBtn withIcon commitBtn greyButton" tabindex="-1">' +
               '        <%=confirmButtonText%>' +
               '      </div>' +
               '      <div class="cancelBtn greyButton"><%=cancelButtonText%></div>' +
               '    </div>' +
               '  </div>' +
               '</div>';
    }

    messageKeys() {
        return {
            confirmationText: 'work_schedule.delete_holidays_confirm_text',
            cancelButtonText: 'common.cancel',
            confirmButtonText: 'work_schedule.delete_holidays_confirm_button'
        };
    }

    afterRender() {
        this.find('.cancelBtn').click(() => this.actions.onCancelButtonClick())
        this.find('.submitBtn').click(() => this.actions.onConfirmButtonClick())

        this.$title = this.find('.title')
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/components/RemoveAllConfirmation.js